import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ContractsComponent } from "./contracts.component";
import { ContractsGuard } from "../../guards/contracts.guard";

const routes: Routes = [
  {
    path: "",
    component: ContractsComponent,
    canActivate: [ContractsGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ContractsRoutingModule {}
